<template>
  <div class="app-wrapper">
    <main>
      <div class="container-fluid mx-0 px-0" style="min-width: 360px;">
        <MainHeader></MainHeader>
        <div v-if="tab === 'intro'">
          <IntroPage></IntroPage>
        </div>
        <div v-if="tab === 'projects'">
          <ProjectPage></ProjectPage>
        </div>
        <div v-if="tab === 'contact'">
          <ContactPage></ContactPage>
        </div>
        <div v-if="tab === 'qa'">
          <QAPage></QAPage>
        </div>


        <div class="fixed-bottom-line-at text-end">
          <a href="https://lin.ee/vqfTBsa" target="_blank">
            <img src="line.png" />
          </a>
        </div>
      </div>
    </main>
    <footer class="footer d-flex justify-content-center align-items-center" style="min-width: 360px;">
      <span class="text-white" style="font-size: 14px;">copyright @ {{ $t('company-name') }}</span>
    </footer>
  </div>
</template>

<script>
import { useI18n } from 'vue-i18n'
import MainHeader from './components/MainHeader.vue';
import IntroPage from './components/IntroPage.vue';
import ContactPage from './components/ContactPage.vue';
import QAPage from './components/QAPage.vue';
import ProjectPage from './components/ProjectPage.vue';

export default {
  components: {
    MainHeader,
    IntroPage,
    ContactPage,
    ProjectPage,
    QAPage
  },
  setup() {
    const { t, locale } = useI18n()
    console.log(locale.value);

    return { t }
  },
  mounted() {
  },
  methods: {
  },
  computed: {
    tab() {
      if (!this.$route.query.tab) {
        return "intro"
      }
      return this.$route.query.tab;
    },
  },
  data() {
    return {
    }
  }
}
</script>

<style>
.fixed-bottom-line-at {
  position: fixed;
  bottom: 20px;
  right: 20px;
}

.fixed-bottom-line-at :hover img {
  opacity: 0.8;
}

.app-wrapper {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
}

main {
  flex: 1 0 auto;
  /* padding-bottom: 94px; */
  /* footer 的高度 */
}

.footer {
  background-color: #10638F;
  height: 94px;
  flex-shrink: 0;
  /* 防止 footer 被壓縮 */
}
</style>